import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from '@mui/material';
import { ThemeProvider as ThemeProviderV4 } from '@material-ui/core/styles';
import { SnackbarProvider } from 'notistack';
import App from './App';
import { store } from './store/store';
import * as serviceWorker from './serviceWorker';
import GlobalStyles from './theme/GlobalStyles';
import cpgTheme from './theme/cpgTheme';
import cpgThemeV4 from './theme/cpgThemeV4';
import { SiteAddress } from './containers/SiteAddress';
import './styles/cpg-tokens.css';
import './styles/cpg-stepper.css';

// Stripe is no longer wrapped globally here — each payment step brings its own
// <Elements> instance keyed to its own PaymentIntent clientSecret. See
// src/components/JobPayment/. loadStripe lives in JobPayment/stripePromise.ts.
ReactDOM.render(
  <HelmetProvider>
    <SnackbarProvider maxSnack={3}>
      <BrowserRouter>
        <Provider store={store}>
          <ThemeProviderV4 theme={cpgThemeV4}>
            <ThemeProvider theme={cpgTheme}>
              <GlobalStyles />
              <SiteAddress>
                <App />
              </SiteAddress>
            </ThemeProvider>
          </ThemeProviderV4>
        </Provider>
      </BrowserRouter>
    </SnackbarProvider>
  </HelmetProvider>,
  document.getElementById('root'),
);

// If you want your store to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
